import { useState } from 'react'
import { useUiLang } from '@/i18n'
import type { Lang } from '@/types/lang'
import type { Instruction } from '../../types'
import { initialEditLang } from '../../lib/editLang'

/** Отметка «язык ещё не выбран»: адрес статьи таким быть не может. */
const PENDING = '\u0000'

/**
 * Язык правки статьи. Стартовый — язык интерфейса (новая статья при английском
 * интерфейсе пишется по-английски). У открытой статьи он сверяется с её текстом
 * один раз на адрес (`initialEditLang`); дальше язык выбирает только автор.
 * `langFor` — для какой статьи выбор сделан (`PENDING` — она ещё не загружена).
 */
export const useEditLang = (
  slug: string | undefined,
  instruction: Instruction | undefined,
): [Lang, (lang: Lang) => void] => {
  const uiLang = useUiLang()
  const [lang, setLang] = useState<Lang>(uiLang)
  const [langFor, setLangFor] = useState<string | undefined>(slug ? PENDING : undefined)

  if (slug !== langFor) {
    if (!slug) {
      // Перешли к новой статье — снова язык интерфейса.
      setLangFor(undefined)
      setLang(uiLang)
    } else if (langFor === undefined) {
      // Статья создана здесь: адрес появился после первого сохранения, язык уже
      // выбран автором — не перещёлкиваем его по тексту.
      setLangFor(slug)
    } else if (instruction) {
      setLangFor(slug)
      setLang(initialEditLang(uiLang, instruction))
    }
  }
  return [lang, setLang]
}
